import { render, staticRenderFns } from "./AddIntroVideo.vue?vue&type=template&id=065b3e3a&scoped=true&lang=pug&"
import script from "./AddIntroVideo.vue?vue&type=script&lang=js&"
export * from "./AddIntroVideo.vue?vue&type=script&lang=js&"
import style0 from "./AddIntroVideo.vue?vue&type=style&index=0&id=065b3e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b3e3a",
  null
  
)

export default component.exports